export default __webpack_public_path__ + "static/media/tailwindcss-icon.50fbcf51.svg";